module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-4-1c986f8ec58b846a5a8ebbb44590b274.svg";